import React from 'react'

const Penalties = () => {
  return (
    <div>Penalties</div>
  )
}

export default Penalties